export const tabsElements = [
  {
    title: 'Information',
    component: () => <></>,
  },
  {
    title: 'Activities',
    component: () => <></>,
  },
  {
    title: 'Access and Permissions',
    component: () => <></>,
  },
];
